import React, { memo } from 'react';
import { Empty, EmptyProps } from 'antd';
import styles from './index.module.scss';

type CustomEmptyProps = {
  image?: string;
  children?: React.ReactNode;
  text?: string;
} & EmptyProps;

const CustomEmpty: React.FC<CustomEmptyProps> = ({
  image = '//assets-oss.cbndata.com/cbndata-refactor-fe/FrjKr0pSfKb6UXasapkQGcupRnrD.png',
  text,
  children,
  ...props
}) => {
  return (
    <Empty
      className={styles.empty}
      image={image}
      description={<span className={styles.text}>{text || '暂无数据'}</span>}
      {...props}
    >
      {children}
    </Empty>
  );
};

export default memo(CustomEmpty);
